import { GameItem } from "@/pages/Game/type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: { recentlyOpenGames: GameItem[] } = {
	recentlyOpenGames: [],
};

const gameSlice = createSlice({
	name: "game",
	initialState,
	reducers: {
		addGame: (state, action: PayloadAction<GameItem>) => {
			const games = state.recentlyOpenGames
			const index = games.findIndex(
				(item) => item.gameId === action.payload.gameId
			);
			if (index !== -1) {
				games.splice(index, 1); // 移除元素
			}
			if (games.length > 10) { // 最多展示10个
				games.length = 10
			}
			games.unshift(action.payload); // 添加新元素
			state.recentlyOpenGames = games;
		},
		removeGame: (state, action: PayloadAction<string>) => {
			state.recentlyOpenGames = state.recentlyOpenGames.filter(
				(todo) => todo.gameId !== action.payload
			);
		},
	},
});

export const { addGame, removeGame } = gameSlice.actions;
export default gameSlice.reducer;
